import React from "react";
import { Input } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Input abbreviation for convention list.
 */
export const InputAbbrev = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-abbrev-error",
  };

  const inputProps = {
    type: "text",
    id: "input-abbrev",
    className: "form-control convention-input",
    "aria-describedby": errorProps.id,
    autoComplete: "off",
    ...props,
  };

  const labelProps = {
    className: "form-control-label",
    htmlFor: inputProps.id,
    children: "TAB ABBREVIATION",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.ABBREV,
  };

  return <Input {...parentProps} />;
};
